import React, { memo, useCallback } from 'react';

import { log } from '../../../services/utils';

import { useAuthAction } from '../../../contexts/AuthContext';
import { useUIAction } from '../../../contexts/UIContext';

import NavItem from '../../Shared/NavItem';

import styles from './sidebar.module.css';

const SidebarRoutes = () => {
	const { signOut } = useAuthAction();
	const { setSidebar } = useUIAction();

	const handleClick = useCallback( () => {
		setSidebar( false );
	}, [ setSidebar ] );

	return (
		<div className={ styles.sidebarMenuContainer }>
			{ log( 'operationsSidebar' ) }
			<NavItem
				className={ styles.sidebarLink }
				icon="check square outline"
				onClick={ handleClick }
				title="To Do"
				to="/todo"
			/>
			<NavItem
				className={ styles.sidebarLink }
				icon="building"
				onClick={ handleClick }
				title="Agency"
				to="/agency"
			/>
			<NavItem
				className={ styles.sidebarLink }
				icon="map pin"
				onClick={ handleClick }
				title="Locations"
				to="/locations"
			/>
			<NavItem
				className={ styles.sidebarLink }
				icon="users"
				onClick={ handleClick }
				title="Staff"
				to="/staff"
			/>
			<NavItem
				className={ styles.sidebarLink }
				icon="clipboard list"
				onClick={ handleClick }
				title="Programs"
				to="/programs"
			/>
			<NavItem
				className={ styles.sidebarLink }
				icon="user"
				onClick={ handleClick }
				title="Profile"
				to="/profile"
			/>
			<NavItem
				className={ styles.sidebarLink }
				icon="sign-out"
				onClick={ signOut }
				title="Logout"
				to="/logout"
			/>
		</div>
	);
};

export default memo( SidebarRoutes );
